export default "/images/check.svg?a6151888542feae6b5840a95a69ed0b8";